import { STORE_PARAMS, STORE_PARAMS_ERROR, LOADING_PARAMS } from './types'

export function storeParams(params) {
    return {
        type: STORE_PARAMS,
        payload: params
    }
}
export function loadingParams() {
    return {
        type: LOADING_PARAMS
    }
}
export function storeParamsError(error) {
    return {
        type: STORE_PARAMS_ERROR,
        payload: error
    }
}